<div class="flex flex-col gap-3 justify-items-center items-center pt-5">
    <p>You have been successfully logged out</p>
  </div>
  